export function getAllShadowRoots(element: Element | ShadowRoot) {
  let searchContext = element;

  const shadowRoots: ShadowRoot[] = [];

  const hasDirectShadowRoot =
    element instanceof Element && !!element.shadowRoot;

  if (hasDirectShadowRoot) {
    shadowRoots.push(element.shadowRoot);
    searchContext = element.shadowRoot;
  }

  const allElements = searchContext.querySelectorAll('*');

  allElements.forEach(({ shadowRoot }) => {
    if (!shadowRoot) {
      return;
    }

    shadowRoots.push(shadowRoot);
    shadowRoots.push(...getAllShadowRoots(shadowRoot));
  });

  return shadowRoots;
}
